angular.module("app").controller("PaymentsPageController", [
    '$scope',
    'paymentsService',
    'logger',
    'errorHandler',
    '$timeout',
    'pagination',
    'preloadedSkinsList',
    'configsService',
    'userStorage',
    'settingsService',
    '$cookies',
    '$uibModal',
    'toolsMap',
    '$rootScope',
    function ($scope, paymentsService, logger, errorHandler, $timeout, pagination, preloadedSkinsList, configsService, userStorage, settingsService, $cookies, $modal, toolsMap, $rootScope) {
        var pendingListRequest,
            requestData = [],
            changes = [],
            init,
            settings = settingsService.getSettings();
        var preloadedData = preloadedSkinsList.skin;
        $scope.languages = settings.skin && settings.skin.languages;
        $scope.selectedLanguage = $cookies.get("preferedLanguage") || (settings.skin && settings.skin.defaultLang);

        $scope.currentEditing = {
            currency: {},
            currencyCode: "",
            depositLang: $scope.selectedLanguage,
            withdrawLang: $scope.selectedLanguage
        };

        $scope.editPayment = function (item, activeTab) {
            $scope.activeTab = activeTab;
            $scope.currentEditing.depositLang = $scope.currentEditing.withdrawLang = $scope.selectedLanguage;

            $scope.item = item;
            if($scope.item.info){
                $scope.item.currencyCodes = [];
                var currencyCodeValueMap = {};
                var j = 0;
               for( var currencyCode in $scope.item.info){
                    if ($scope.item.info.hasOwnProperty(currencyCode)) {
                        $scope.item.currencyCodes.push(currencyCode);
                        currencyCodeValueMap[currencyCode] = $scope.item.info[currencyCode];
                        if(j === 0){
                            $scope.setCurrentEditingCurrency( $scope.item.info[currencyCode], currencyCode);
                        }
                    }
               }
               $scope.changeCurrency = function () {
                   $scope.currentEditing.currency = currencyCodeValueMap[$scope.currentEditing.currencyCode];
               };
            }
            $scope.item.uploaded_image = "";
            $modal.open({
                templateUrl: "views/payments/editPayment.html",
                controller: 'PaymentEditPageModalController',
                scope: $scope
            }).result.then(function () {
               $scope.updateList();
            }, function () {
                var index = $scope.list.indexOf(item),
                    sourceData = $scope.sourceData.payments[index];
                    $scope.list[index] = angular.copy(sourceData);
                    $scope.item =  $scope.list[index];
                    $rootScope.broadcast("updateTable");

            });
        };

        $scope.ignoreColumns = {
            'is_enabled': true,
            'customImage': true,
            'image': true,
            'info': true,
            'descriptions': true,
            'currencyCodes': true,
            'uploaded_image': true
        };
        if (userStorage.getUserData().permissions.indexOf('managePayments') !== -1) {
            $scope.tools = {
                /*"switch": {
                    name: function (item) {
                        return 'enabled' + item.id;
                    },
                    model: function () {
                        return "is_enabled";
                    },
                    change: function (item) {
                        $scope.toggleEnabled(item);
                    }
                },*/
                buttonsByCurrencies: {
                    action: function (item) {
                        $scope.editPayment(item, 'currency');
                    },
                    title: function () {
                        return 'Buttons By Currencies';
                    },
                    class: function () {
                        return "buttons-by-currencies";
                    }
                },
                uploadLogo: {
                    action: function (item) {
                        $scope.editPayment(item, 'image');
                    },
                    title: function () {
                        return 'Upload Logo';
                    },
                    class: function () {
                        return "upload-logo";
                    }
                },
                descriptions: {
                    action: function (item) {
                        $scope.editPayment(item, 'deposit');
                    },
                    title: function () {
                        return 'Descriptions';
                    },
                    class: function () {
                        return "descriptions";
                    }
                }
            };
        }

        $scope.extendDeep = function extendDeep(dst) {
            angular.forEach(arguments, function(obj) {
                if (obj !== dst) {
                    angular.forEach(obj, function(value, key) {
                        if (dst[key] && dst[key].constructor && dst[key].constructor === Object) {
                            extendDeep(dst[key], value);
                        } else {
                            dst[key] = angular.copy(value);
                        }
                    });
                }
            });
            return dst;
        };

        $scope.initialData = angular.copy(preloadedData.payments);

        $scope.defaultCurrentEditing = {
            currency: {},
            currencyCode: ""
        };

        $scope.setCurrentEditingCurrency = function (prop, code) {
            $scope.currentEditing.currency = prop;
            $scope.currentEditing.currencyCode = code
        };

        $scope.sourceData = {};

        $scope.skinsList = angular.copy(preloadedSkinsList.skins);

        $scope.search = {
            query: ''
        };

        $scope.filterOptions = {
            skinId: preloadedSkinsList.skinId
        };

        $scope.closeAllAndOpenCurrent = function (item) {
            for (var i = 0, length = $scope.list.length; i < length; i++) {
                if ($scope.list[i].isEdit && $scope.list[i] != item) {
                    delete $scope.list[i].isEdit;
                }
            }
            item.isEdit = !item.isEdit;
        };

        $scope.closeAllDefaultsAndOpenCurrent = function (current, forceEdit) {
            angular.forEach($scope.defaults, function (item) {
                if (item !== current) {
                    delete item.isEdit
                }
            });
            current.isEdit = forceEdit || !current.isEdit;
        };

        $scope.pagination = pagination.init(function () {
            $scope.selectPayments({
                    current_page: $scope.pagination.page,
                    limit: $scope.pagination.limit
            })
        }, preloadedData.payments.length, 25);

        $scope.updateList = function () {
            var requestObject = {
                skin_id: $scope.filterOptions.skinId
            };


            paymentsService.getList(requestObject).then(
                function (response) {
                    if (response.status == "ok") {
                        $scope.initialData = response.payments;
                        init(response)
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.filterForRemove = function (skin) {
            if (!!$scope.search.query) {
                var regex = new RegExp("^" + $scope.search.query.toLowerCase());

                if (regex.test(skin.name.toLowerCase()) || regex.test(skin.id)) {
                    return true
                }
            } else {
                return true
            }
            return false
        };

        $scope.generate = function () {
            configsService.applyPayments({skin_id: $scope.filterOptions.skinId}).then(
                function (response) {
                    if (response.status == "ok") {
                        logger.logSuccess("global.configApplied");
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };
        $scope.generateJs = function () {
            configsService.generateJs({skin_id: $scope.filterOptions.skinId}).then(
                function (response) {
                    if (response.status == "ok") {
                        logger.logSuccess("global.generated");
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };
        
        $scope.toggleEnabled = function (item) {
            var index = requestData.indexOf(item);
            if (index == -1) {
                requestData.push(item)
            } else {
                requestData.splice(index, 1);
            }
        };

        $scope.add = function (arr) {
            arr.push(0);
        };

        $scope.remove = function (arr, index) {
            arr.splice(index, 1);
        };

        /*
         changeSet generator method
         * currentValue is equal to current state of array changes are included
         * transactionType deposit/withdraw
         * paymentMethod witch has been change
         * currencyName witch currency has been changed */
        $scope.whenChange = function (currentValue, transactionType, paymentMethod, currencyName) {
            var index = $scope.list.indexOf(paymentMethod),
                changesetIndex = changes.indexOf(paymentMethod),
                isChanged = false,
                sourceData = $scope.sourceData.payments[index].info[currencyName].default[transactionType],
                i = 0,
                length = currentValue.length;

            if (changesetIndex !== -1) {
                changes.splice(changesetIndex, 1);
            }

            for (; i < length; i++) {
                if (sourceData[i] != currentValue[i]) {
                    isChanged = true;
                    break;
                }
            }

            !isChanged && (isChanged = (sourceData.length !== currentValue.length));

            if (isChanged) {
                changes.push(paymentMethod)
            }
        };


        $scope.changeCurrentLang = function () {
            $scope.$broadcast("force:reset:editor");
        };

        /*
         save single method changes
         * method changed method*/
        $scope.saveMethod = function (method) {
            var index = $scope.list.indexOf(method),
                sourceData = $scope.sourceData.payments[index],
                requestData = toBackendObject(method, sourceData);

            if (!requestData) {
                logger.logError("global.no_changes");
                return;
            }

            if (requestData.payments) {
                var initialData = getInitialData(Number(requestData.payments[0].payment_id));
                requestData.payments[0] = $scope.extendDeep(initialData, requestData.payments[0]);

                $scope.initialData[getIndex(Number(requestData.payments[0].payment_id))] = requestData.payments[0];

                angular.forEach(requestData.payments[0].info, function (currencyObj) {
                    if (currencyObj && currencyObj.default) {
                        var deposit = currencyObj.default.deposit || [],
                            withdraw = currencyObj.default.withdraw || [];
                        deposit.length + withdraw.length === 0 && (currencyObj.default = false);
                    }
                });
            }

            processRequest(requestData)
        };

        function processRequest(requestData) {
            paymentsService.changeState(requestData).then(
                function (response) {
                    if (response.status == "ok") {
                        logger.logSuccess("global.configApplied");
                        $scope.sourceData.default = angular.copy($scope.defaults);
                        $scope.sourceData.payments = angular.copy($scope.list);
                        $scope.$modalInstance.close();
                    } else {
                        errorHandler(response.message)
                    }
                },
                function () {
                    errorHandler(response.message)
                }
            )
        }

        /*
         request data generator comparing current changes with source data
         * method changed method
         * sourceData source data not changed */
        function toBackendObject(current, source) {
            var _ = {
                skin_id: $scope.filterOptions.skinId,
                payments: [{
                    name: current.name,
                    payment_id: current.payment_id,
                    is_enabled: Number(current.is_enabled)
                }]
            }, info = getChangedArrays(current.info, source.info), descriptions = getChangedDescriptions(current.descriptions, source.descriptions)

            _.payments[0].image = current.uploaded_image || current.image;

            !!current.uploaded_image ? (_.payments[0].customImage = 1) : (_.payments[0].customImage = 0);

            if (Object.keys(info).length) {
                (_.payments[0].info = info);
            }
            
            if (Object.keys(descriptions).length) {
                (_.payments[0].descriptions = descriptions);
            }
            
            return getChanges(_, source);
        }

        function getChangedDescriptions(current, source) {
            var changes = {};
            angular.forEach(current, function (value, key) {
                if (!source[key]) {
                    changes[key] = value;
                } else {
                    angular.forEach(value, function (value1, key1) {
                        if (!source[key][key1] || source[key][key1] != current[key][key1]) {
                            if (key in changes) {
                                changes[key][key1] = value1;
                            } else {
                                changes[key] = {};
                                changes[key][key1] = value1;
                            }
                        }
                    })
                }

            });

            return changes
        }
        
        function getChangedArrays(current, source) {
            var changes = {};
            angular.forEach(current, function (currencyInfo, currencyCode) {
                var isChanged = false;
                angular.forEach(currencyInfo.default, function (transactionTypeDefaultsArr, transactionType) {
                    var i = 0,
                        length = transactionTypeDefaultsArr.length;
                    for (; i < length; i++) {
                        if (source[currencyCode].default[transactionType][i] != transactionTypeDefaultsArr[i]) {
                            isChanged = true;
                            break;
                        }
                    }
                    !isChanged && (isChanged = (source[currencyCode].default[transactionType].length !== transactionTypeDefaultsArr.length));
                });

                if (isChanged) {
                    changes[currencyCode] = {};
                    changes[currencyCode].default = angular.copy(currencyInfo.default);
                    return changes
                }
            });
            return changes
        }

        function getChanges(collectedData, sourceData) {
            var singleItem = collectedData.payments[0];

            if (singleItem.hasOwnProperty("info") || singleItem.hasOwnProperty("descriptions") || Number(singleItem.is_enabled) !== Number(sourceData.is_enabled) || singleItem.image != sourceData.image) {
                return collectedData
            }
        }

        $scope.isDefaultChanged = function (currency, key) {
            return !$scope.saveDefaultCurrency(currency, key, true)
        };

        /*global defaults save and equality checkers
         * currency /each currency sould have 2 props deposit and withdraw thats shold were arrays
         * key currency code 'USD, ARM, RU ...'
         * */

        $scope.saveDefaultCurrency = function (currency, key, checkEquality) {
            var sourceData = $scope.sourceData.default[key],
                current = angular.copy(currency),
                isChanged = false,
                changes = {};
            delete current.isEdit;


            angular.forEach(current, function (arr, transactionType) {
                var i = 0,
                    lenght = arr.length;

                for (; i < lenght; i++) {
                    if (arr[i] != sourceData[transactionType][i]) {
                        isChanged = true;
                        break;
                    }
                }

                !isChanged && (isChanged = (arr.length !== sourceData[transactionType].length));

                if (isChanged) {
                    changes[transactionType] = angular.copy(arr);
                }
            });

            if (checkEquality || !isChanged) {
                return isChanged
            }

            var all = angular.copy($scope.defaults);
            all[key] = current;

            processRequest({'skin_id': $scope.filterOptions.skinId, 'default': all})
        };
        $scope.selectPayments = function (request) {
            if (!$scope.allList) {
                return;
            }
            if ($scope.search.query){
                $scope.list = $scope.allList.filter(function (item) {
                    return item.name.toLowerCase().indexOf($scope.search.query.toLowerCase()) !== -1 || item.payment_id.toString().indexOf($scope.search.query) === 0;
                });
            } else {
                $scope.list = $scope.allList;
            }
            $scope.pagination.totalItems = $scope.list.length;
            $scope.list =  $scope.list.slice((request.current_page - 1) * request.limit, (request.current_page - 1) * request.limit + request.limit);
            $scope.sourceData.payments = angular.copy($scope.list);
        };

        /*init method*/
        (init = function (response) {
            $scope.pagination.totalItems = response.payments.length;
            $scope.languages = response.languages;
            $scope.currentEditing.depositLang = $scope.currentEditing.withdrawLang = $scope.selectedLanguage = response.defaultLang;
            $scope.currentEditing.currency = {};
            $scope.defaultCurrentEditing.currency = {};
            $scope.currentEditing.currencyCode = "";
            $scope.defaultCurrentEditing.currencyCode = "";
            $scope.pagination.page = 1;
            requestData = [];
            changes = [];

            $scope.defaults = angular.copy(response.default);
            $scope.allList = response.payments.reduce(function (list, current) {
                var info = current.info;
                angular.forEach(info, function (currency) {

                    var canDeposit,
                        canWithdraw,
                        str = Object.keys(currency).join("");

                    canDeposit = str.indexOf("deposit") !== -1;
                    canWithdraw = str.indexOf("withdraw") !== -1;

                    currency.default = currency.default || {};
                    canDeposit && (currency.default.deposit = currency.default.deposit || []);
                    canWithdraw && (currency.default.withdraw = currency.default.withdraw || [])

                });
                list.push(current);
                return list
            }, []);
            $scope.selectPayments({
                current_page: $scope.pagination.page,
                limit: $scope.pagination.limit
            });
            $scope.sourceData.default = angular.copy($scope.defaults);
            $scope.sourceData.payments = angular.copy($scope.list);
        })(preloadedData);

        function getInitialData (paymentId) {
            var i = 0,
                length = $scope.initialData.length;

            for (; i < length; i++) {
                if ($scope.initialData[i].payment_id === paymentId) {
                    return angular.copy($scope.initialData[i]);
                }
            }
        }

        function getIndex (paymentId) {
            var i = 0,
                length = $scope.initialData.length;

            for (; i < length; i++) {
                if ($scope.initialData[i].payment_id === paymentId) {
                    return i
                }
            }
        }
        $scope.listFilterObject = {
            action: function () {
                $scope.selectPayments({
                    current_page: $scope.pagination.page,
                    limit: $scope.pagination.limit
                });
            }
        };

        $scope.initCurrency = function () {
            $scope.defaultCurrentEditing.currency = {};
            $scope.defaultCurrentEditing.currencyCode = "";
            $scope.defaults = angular.copy($scope.sourceData.default);
            var j = 0;
            $scope.currencyKeys = [];
            for(var currencyKey in $scope.defaults){
                if($scope.defaults.hasOwnProperty(currencyKey)){
                    if (j === 0){
                        var value_currency = $scope.defaults[currencyKey];
                        $scope.closeAllDefaultsAndOpenCurrent(value_currency, true);
                        $scope.defaultCurrentEditing.currency = value_currency;
                        $scope.defaultCurrentEditing.currencyCode = currencyKey;
                    }
                    $scope.currencyKeys.push(currencyKey);
                    ++j;

                }
            }
        };

        $scope.changeDefaultCurrency = function () {
            value_currency = $scope.defaults[$scope.defaultCurrentEditing.currencyCode];
            !value_currency.isEdit && $scope.closeAllDefaultsAndOpenCurrent(value_currency); $scope.defaultCurrentEditing.currency = value_currency;
        };

        $scope.load = function (dataUrl) {
            $scope.item.uploaded_image = dataUrl;
            $timeout(function () {
                $scope.$apply();
            });
        };

        $scope.initModalInstance = function ($modalInstance) {
            $scope.$modalInstance = $modalInstance;
        }

        $scope.showButtonsByCurrencies = function showButtonsByCurrencies() {
            $modal.open({
                templateUrl: "views/payments/buttonsByCurrencies.html",
                controller: 'PaymentEditPageModalController',
                scope: $scope
            })
        }
    }
]);
